import { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Col, Form, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";

import SweetAlert from "react-bootstrap-sweetalert";
import DataTable from "react-data-table-component";
import { FaBars, FaCopy, FaEdit, FaEye, FaMinus, FaPlus, FaPrint, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AsyncPaginate } from "react-select-async-paginate";
import Card from "../../../components/Card";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import JenisKomoditi from "../../../utilities/JenisKomoditi";
import Negara from "../../../utilities/Negara";
import StatusDok from "../../../utilities/StatusDok";
import UPT from "../../../utilities/UPT";
import { formatDateTimeLocalDate, romanNum } from "../../../utilities/Utils";
import ModalCetakPermohonan from "../../penugasan/modals/ModalCetakPermohonan";
import ModalLog from "../../penugasan/modals/ModalLog";
import ExpandableComponent from "./expand/ExpandableComponent";
import PbUmkuService from "../../../services/pbumku/PbumkuService";


const OnProcess = () => {

    let navigate = useNavigate()

    const columns = [
        {
            name: 'Nomor Aju',
            cell: row => row['nomorAju'],
            grow: 0.6
        },
        {
            name: 'Tanggal Aju',
            cell: row => formatDateTimeLocalDate(row['tanggalAju']),
            grow: 0.3
        },
        {
            name: 'UPT',
            cell: row => (<>{row['kdUpt']} - <UPT id={row['kdUpt']} /></>),
        },
        {
            name: 'Nama',
            cell: row => row['namaTrader'],
            grow: 0.5
        },
        {
            name: 'Tujuan',
            cell: row => <Negara id={row['negaraPartner']} />,
            grow: 0.5
        },
        {
            name: 'Jenis Komoditi',
            cell: row => <JenisKomoditi id={row['jenisKomoditi']} />,
            grow: 0.25
        },
        {
            name: 'Peruntukan',
            cell: row => row['peruntukan'] === '1' ? 'Konsumsi' : 'Non Konsumsi',
            grow: 0.25
        },
        {
            name: 'Status',
            cell: row => <StatusDok kodeStatus={row['status']} />,
            grow: 0.5
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className="row">
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Cetak Permohonan</Tooltip>}>
                                <Button size="sm" variant="success" onClick={() => CetakPermohonan(row)}>
                                    <FaPrint /> Cetak
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat Permohonan</Tooltip>}>
                                <Button size="sm" variant="info" onClick={() => ViewDok(row['nomorAju'], '0')}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        {
                            row['status'] === '027' &&
                            <div className="col-12 mb-1">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Ubah Permohonan</Tooltip>}>

                                    <Button size="sm" variant="warning" onClick={() => ViewDok(row['nomorAju'], '1')}>
                                        <FaEdit /> Ubah
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        }
                        {
                            row['status'] !== '028' &&
                            <div className="col-12 mb-1">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Hapus Permohonan</Tooltip>}>
                                    <Button size="sm" variant="danger" onClick={() => HapusDok(row)}>
                                        <FaTrash /> Hapus
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div>
                        }
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Duplikat Permohonan</Tooltip>}>
                                <Button size="sm" variant="light" onClick={() => CopyPermohonan(row)}>
                                    <FaCopy /> Copy
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >History Permohonan</Tooltip>}>
                                <Button size="sm" variant="secondary" onClick={() => ViewLogStatus(row)}>
                                    <FaBars /> History
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                    </div>
                </>
            ),
            grow: 0.5
        },
    ]

    const [rowData, setRowData] = useState(null)
    const [showCetak, setShowCetak] = useState(false)
    const handleCloseCetak = () => setShowCetak(false)

    const CetakPermohonan = (rowdata) => {
        setRowData(rowdata)
        setShowCetak(true)
    }

    const ViewDok = (noAju, isEdit) => {
        localStorage.removeItem('isEditStorage')
        localStorage.removeItem('nomorAjuStorage')
        localStorage.setItem('nomorAjuStorage', noAju)
        localStorage.setItem('isEditStorage', isEdit)
        navigate('/permohonan/ekspor/view-2')
    }

    const [showConfirmHapus, setShowConfirmHapus] = useState(false)
    const handleCloseConfirmHapus = () => setShowConfirmHapus(false)
    const [showHapusSuccess, setShowHapusSucces] = useState(false)
    const [showHapusFailed, setShowHapusFailed] = useState(false)
    const [loadingHapus, setLoadingHapus] = useState(false)

    const HapusDok = (rowdata) => {
        setShowConfirmHapus(true)
        setRowData(rowdata)
    }

    const handleClickHapus = async () => {
        setLoadingHapus(true)
        try {
            let jsonHapusData = { ...rowData, status: '120' }

            const response = await transaksiService.addPpm(JSON.stringify(jsonHapusData))
            if (response.data.kode === '200') {
                setShowHapusSucces(true)
                setShowConfirmHapus(false)
            } else {
                setShowHapusFailed(true)
            }
        } catch (error) {
            setShowHapusFailed(true)
        }
        setLoadingHapus(false)
    }

    const handleClickHapusSuccess = () => {
        setShowHapusSucces(false)
        getListPpm(0, 10)
    }

    const handleClickHapusFailed = () => {
        setShowHapusFailed(false)
    }

    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    const [showConfirmCopy, setShowConfirmCopy] = useState(false)
    const handleCloseConfirmCopy = () => setShowConfirmCopy(false)
    const [loadingCopy, setLoadingCopy] = useState(false)
    const [showCopySuccess, setShowCopySucces] = useState(false)
    const [showCopyFailed, setShowCopyFailed] = useState(false)
    const [newAju, setNewAju] = useState(null)

    const CopyPermohonan = (rowdata) => {
        setRowData(rowdata)
        setShowConfirmCopy(true)
    }

    const handleClickCopy = async () => {
        setLoadingCopy(true)
        try {
            const respNomor = await pbumkuService.ambilNomorService('PPM_AJU', rowData.kdUpt, currentYear, localStorage.getItem('username'))
            let nomorAjuBaru = respNomor.data.uraianPusat + respNomor.data.kodePusat + romanNum(currentMonth) + currentYear + respNomor.data.nomorUrut

            const response = await transaksiService.copyPermohonan(rowData.nomorAju, nomorAjuBaru)
            if (response.data.kode === '200') {
                setNewAju(response.data.id)
                setShowCopySucces(true)
                setShowConfirmCopy(false)
            } else {
                setShowCopyFailed(true)
            }
        } catch (error) {
            setShowCopyFailed(true)
        }
        setLoadingCopy(false)
    }

    const handleClickCopySuccess = () => {
        setShowCopySucces(false)
        getListPpm(0, 10)
    }

    const handleClickCopyFailed = () => {
        setShowCopyFailed(false)
    }

    const [showLog, setShowLog] = useState(false)
    const handleCloseLog = () => setShowLog(false)

    const ViewLogStatus = (rowdata) => {
        setRowData(rowdata)
        setShowLog(true)
    }

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])

    const [listPpm, setListPpm] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getListPpm = useCallback(async (page, size) => {
        setLoading(true)
        try {
            if (localStorage.getItem("kodeTrader") !== null) {
                const trader = await userService.getTraderById(localStorage.getItem("kodeTrader"))

                const responseKirim = await transaksiService.listPpm(null, trader.data.npwp, '010', page, size)
                let arrDataResponseKirim = responseKirim.data.data

                const responseProses = await transaksiService.listPpm(null, trader.data.npwp, '020', page, size)
                let arrDataResponseProses = responseProses.data.data

                const responseEvp = await transaksiService.listPpm(null, trader.data.npwp, '021', page, size)
                let arrDataResponseEvp = responseEvp.data.data

                const responseVlap = await transaksiService.listPpm(null, trader.data.npwp, '022', page, size)
                let arrDataResponseVlap = responseVlap.data.data

                // const responseOrg = await transaksiService.listPpm(null, trader.data.npwp, '023', page, size)
                // let arrDataResponseOrg = responseOrg.data.data

                const responseDraftHc = await transaksiService.listPpm(null, trader.data.npwp, '025', page, size)
                let arrDataResponseDraftHc = responseDraftHc.data.data

                const responseDraftHcProses = await transaksiService.listPpm(null, trader.data.npwp, '026', page, size)
                let arrDataResponseDraftHcProses = responseDraftHcProses.data.data

                const responseDraftHcVerifikasi = await transaksiService.listPpm(null, trader.data.npwp, '027', page, size)
                let arrDataResponseDraftHcVerifikasi = responseDraftHcVerifikasi.data.data

                const responseDraftHcSetuju = await transaksiService.listPpm(null, trader.data.npwp, '028', page, size)
                let arrDataResponseDraftHcSetuju = responseDraftHcSetuju.data.data

                const responseHcProses = await transaksiService.listPpm(null, trader.data.npwp, '029', page, size)
                let arrDataResponseHcProses = responseHcProses.data.data

                const responsePnbp = await transaksiService.listPpm(null, trader.data.npwp, '024', page, size)
                let arrDataResponsePnbp = responsePnbp.data.data

                let newArr = [...arrDataResponseKirim, ...arrDataResponseProses, ...arrDataResponseEvp, ...arrDataResponseVlap,
                ...arrDataResponseDraftHc, ...arrDataResponsePnbp,
                ...arrDataResponseDraftHcProses, ...arrDataResponseDraftHcVerifikasi,
                ...arrDataResponseDraftHcSetuju, ...arrDataResponseHcProses]

                // responseKirim = await transaksiService.listPpm(null, trader.data.npwp, null, page, size)
                // console.log(Number(responseKirim.data.totalData))
                setListPpm(newArr)
                setTotalData(Number(responseKirim.data.totalData) + Number(responseProses.data.totalData) + Number(responseEvp.data.totalData) + Number(responseVlap.data.totalData) +
                    Number(responseDraftHc.data.totalData) + Number(responsePnbp.data.totalData) +
                    Number(responseDraftHcProses.data.totalData) + Number(responseDraftHcVerifikasi.data.totalData) +
                    Number(responseDraftHcSetuju.data.totalData) + Number(responseHcProses.data.totalData))
                // setTotalData(responseKirim.data.totalData)
            } else {
                const responseKirim = await transaksiService.listPpm(null, null, null, page, size)
                setListPpm(responseKirim.data.data)
                setTotalData(responseKirim.data.totalData)
            }
        } catch (error) {
            console.log(error)
            setListPpm([])
        }
        setLoading(false)
    }, [transaksiService, userService])

    useEffect(() => {
        getListPpm(0, 10)
    }, [getListPpm])

    const handleChangePage = (page) => {
        getListPpm(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        let _res = null
        if (localStorage.getItem("kodeTrader") !== null) {
            const trader = await userService.getTraderById(localStorage.getItem("kodeTrader"))
            _res = await transaksiService.listPpm(null, trader.data.npwp, null, page - 1, size)
        } else {
            _res = await transaksiService.listPpm(null, null, null, page - 1, size)
        }
        setListPpm(_res.data.data)
        setSize(size)
    }

    const handleClickReset = () => {
        setValueSearchAju('')
        setValueUptOpt(null)
        getListPpm(0, 10)
    }

    const handleClickCari = async (page, size) => {
        if (localStorage.getItem("kodeTrader") !== null) {
            const trader = await userService.getTraderById(localStorage.getItem("kodeTrader"))
            const responseKirim = await transaksiService.listPpmPerUpt(valueSearchAju, trader.data.npwp, valueUptOpt !== null ? valueUptOpt.kdUnit : null, '010', page, size)
            let arrDataResponseKirim = responseKirim.data.data

            const responseProses = await transaksiService.listPpmPerUpt(valueSearchAju, trader.data.npwp, valueUptOpt !== null ? valueUptOpt.kdUnit : null, '020', page, size)
            let arrDataResponseProses = responseProses.data.data

            const responseEvp = await transaksiService.listPpmPerUpt(valueSearchAju, trader.data.npwp, valueUptOpt !== null ? valueUptOpt.kdUnit : null, '021', page, size)
            let arrDataResponseEvp = responseEvp.data.data

            const responseVlap = await transaksiService.listPpmPerUpt(valueSearchAju, trader.data.npwp, valueUptOpt !== null ? valueUptOpt.kdUnit : null, '022', page, size)
            let arrDataResponseVlap = responseVlap.data.data

            // const responseOrg = await transaksiService.listPpm(null, trader.data.npwp, '023', page, size)
            // let arrDataResponseOrg = responseOrg.data.data

            const responseDraftHc = await transaksiService.listPpmPerUpt(valueSearchAju, trader.data.npwp, valueUptOpt !== null ? valueUptOpt.kdUnit : null, '025', page, size)
            let arrDataResponseDraftHc = responseDraftHc.data.data

            const responseDraftHcProses = await transaksiService.listPpmPerUpt(valueSearchAju, trader.data.npwp, valueUptOpt !== null ? valueUptOpt.kdUnit : null, '026', page, size)
            let arrDataResponseDraftHcProses = responseDraftHcProses.data.data

            const responseDraftHcVerifikasi = await transaksiService.listPpmPerUpt(valueSearchAju, trader.data.npwp, valueUptOpt !== null ? valueUptOpt.kdUnit : null, '027', page, size)
            let arrDataResponseDraftHcVerifikasi = responseDraftHcVerifikasi.data.data

            const responseDraftHcSetuju = await transaksiService.listPpmPerUpt(valueSearchAju, trader.data.npwp, valueUptOpt !== null ? valueUptOpt.kdUnit : null, '028', page, size)
            let arrDataResponseDraftHcSetuju = responseDraftHcSetuju.data.data

            const responseHcProses = await transaksiService.listPpmPerUpt(valueSearchAju, trader.data.npwp, valueUptOpt !== null ? valueUptOpt.kdUnit : null, '029', page, size)
            let arrDataResponseHcProses = responseHcProses.data.data

            const responsePnbp = await transaksiService.listPpmPerUpt(valueSearchAju, trader.data.npwp, valueUptOpt !== null ? valueUptOpt.kdUnit : null, '024', page, size)
            let arrDataResponsePnbp = responsePnbp.data.data

            let newArr = [...arrDataResponseKirim, ...arrDataResponseProses, ...arrDataResponseEvp, ...arrDataResponseVlap,
            ...arrDataResponseDraftHc, ...arrDataResponsePnbp,
            ...arrDataResponseDraftHcProses, ...arrDataResponseDraftHcVerifikasi,
            ...arrDataResponseDraftHcSetuju, ...arrDataResponseHcProses]

            // responseKirim = await transaksiService.listPpm(null, trader.data.npwp, null, page, size)
            // console.log(Number(responseKirim.data.totalData))
            setListPpm(newArr)
        } else {
            const _res = await transaksiService.listPpm(valueSearchAju, null, null, page - 1, size)
            setListPpm(_res.data.data)
        }
        setSize(size)
    }

    const [valueSearchAju, setValueSearchAju] = useState(null)
    const onChangeSearchAju = e => {
        setValueSearchAju(e.target.value)
    }

    const [valueUptOpt, setValueUptOpt] = useState(null)
    async function loadOptionUpt(search, loadedOption, { page = 1 }) {
        const response = await userService.listUpt(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeUpt = e => {
        setValueUptOpt(e)
    }

    // const [valueNegaraOpt, setValueNegaraOpt] = useState(null)
    // async function loadOptionNegara(search, loadedOption, { page = 1 }) {
    //     const response = await masterService.listNegara(search, page - 1, 10)
    //     return {
    //         options: response.data.data,
    //         hasMore: response.data.data.length >= 10,
    //         additional: {
    //             page: page + 1
    //         }
    //     }
    // }
    // const onChangeNegara = e => {
    //     setValueNegaraOpt(e)
    // }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-3">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">No. Aju</Form.Label>
                                            <Col sm="9">
                                                <Form.Control type="searchNib" placeholder="Nomor Aju" className="form-control-sm" value={valueSearchAju} onChange={onChangeSearchAju} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">UPT</Form.Label>
                                            <Col sm="10">
                                                <AsyncPaginate
                                                    loadOptions={loadOptionUpt}
                                                    value={valueUptOpt}
                                                    getOptionValue={(option) => option.kdUnit}
                                                    getOptionLabel={(option) => option.nmPendekBaru +  ' d/h ' + option.nmUnit}
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                    onChange={onChangeUpt}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                                {/* <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Negara Tujuan</Form.Label>
                                            <Col sm="8">
                                                <AsyncPaginate
                                                    loadOptions={loadOptionNegara}
                                                    value={valueNegaraOpt}
                                                    getOptionValue={(option) => option.kodeNegara}
                                                    getOptionLabel={(option) => option.kodeNegara + ' - ' + option.uraianNegara}
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                    onChange={onChangeNegara}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div> */}
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari(0, 10)}>Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Permohonan Pemeriksaan Mutu Dalam Proses</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listPpm}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                    expandableRows
                                    expandOnRowDoubleClicked
                                    expandableRowsComponent={({ data }) => <ExpandableComponent data={data} reloadList={getListPpm} />}
                                    expandableIcon={{
                                        collapsed: <FaPlus size={12} color="blue" />, // Custom expand icon
                                        expanded: <FaMinus size={12} color="red" />,   // Custom collapse icon
                                    }}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ModalCetakPermohonan showCetak={showCetak} handleCloseCetak={handleCloseCetak} datappm={rowData} />
            <ModalLog showLog={showLog} handleCloseLog={handleCloseLog} datappm={rowData} />
            {
                showConfirmHapus &&
                <SweetAlert
                    title="Hapus Permohonan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingHapus ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Hapus...
                            </>
                        ) : (
                            "Hapus"
                        )
                    }
                    confirmBtnBsStyle="danger"
                    cancelBtnText="Kembali"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickHapus}
                    onCancel={handleCloseConfirmHapus}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                >
                    {loadingHapus && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Hapus data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showHapusSuccess &&
                <SweetAlert
                    success
                    title="Hapus Data Berhasil"
                    onConfirm={handleClickHapusSuccess}
                    btnSize="sm"
                />
            }
            {
                showHapusFailed &&
                <SweetAlert
                    danger
                    title="Hapus Data Gagal"
                    onConfirm={handleClickHapusFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showConfirmCopy &&
                <SweetAlert
                    title="Copy Permohonan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingCopy ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Copy...
                            </>
                        ) : (
                            "Copy"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Kembali"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickCopy}
                    onCancel={handleCloseConfirmCopy}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                >
                    {loadingCopy && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Copy data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showCopySuccess &&
                <SweetAlert
                    success
                    title="Copy Data Berhasil"
                    onConfirm={handleClickCopySuccess}
                    btnSize="sm"
                >Nomor Aju Baru : {newAju}</SweetAlert>
            }
            {
                showCopyFailed &&
                <SweetAlert
                    danger
                    title="Copy Data Gagal"
                    onConfirm={handleClickCopyFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    );
};

export default OnProcess;
